import { React, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import userManagement from '../../../../services/userManagement';
import ImageUpload from '../../menus/addItems/imagUpload';
import ApiService from '../../../../services/apiService';

const DeliveryPlatforms = () => {
  let navigate = useNavigate();
  const location = useLocation();
  const { Delivery: deliveryData, isEditMode } = location.state || { Delivery: null, isEditMode: false };
  const initialFormData = {
    name: '',
    images: [],
    imageUrl: '',
  };

  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    if (isEditMode && deliveryData) {
      setFormData({
        name: deliveryData.name,
        images: [], // Assume images are not provided directly; they would be handled separately if needed
        imageUrl: deliveryData.imageUrl,
      });
    }
  }, [isEditMode, deliveryData]);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleImagesSelect = (images) => {
    setFormData({ ...formData, images: images });
  };

  const handleImageRemove = (index) => {
    const updatedImages = [...formData.images];
    updatedImages.splice(index, 1);
    setFormData({ ...formData, images: updatedImages });
  };

  const handleSubmit = async () => {
    if (isEditMode) {
      await updateDelivery();
    } else {
      await createDelivery();
    }
  };

  const createDelivery = async () => {
    try {
      if (!formData?.images.length && !formData?.imageUrl) {
        toast.error('Upload Image');
        return;
      } else if (formData?.images.length > 0) {
        const imageUrl = await uploadImages(formData.images);
        if (!imageUrl) {
          toast.error('Image upload failed');
          return;
        }
        await createDeliveryWithImage(imageUrl);
      } else {
        await createDeliveryWithImage(formData.imageUrl);
      }
    } catch (error) {
      console.error('Error creating Delivery:', error);
    }
  };

  const uploadImages = async (images) => {
    try {
      const apiService = new ApiService();
      const formdata = new FormData();
      for (const image of images) {
        if (image.file) {
          formdata.append('Images', image?.file);
        }
      }
      const response = await apiService.postMultiPart('UPLOAD_IMG', formdata);
      if (response?.data?.statusCode === 201) {
        return response?.data?.result;
      }
    } catch (error) {
      console.error('Error uploading images:', error);
      toast.error('Something went wrong with the image. Please try again!');
    }
    return null;
  };

  const createDeliveryWithImage = async (imageUrl) => {
    try {
      const UserId = await userManagement.getUserId();
      const body = {
        name: formData.name,
        logo: imageUrl,
        loggedInUserId: UserId,
        isActive: true,
      };
      const apiService = new ApiService();

      let res = await apiService.post('CREATE_DELIVERY', body);
      if (res?.data?.statusCode === 201) {
        toast.success('Delivery Created Successfully');
        setFormData(initialFormData);
        navigate('/home');
      }
    } catch (error) {
      console.error('Error creating Delivery:', error);
    }
  };

  const updateDelivery = async () => {
    try {
      const apiService = new ApiService();
      const userId = await userManagement.getUserId();

      // Check if new images are selected for upload
      let imageUrl = formData.imageUrl;
      if (formData.images.length > 0) {
        imageUrl = await uploadImages(formData.images);
        if (!imageUrl) {
          toast.error('Image upload failed');
          return;
        }
      }

      const body = {
        id: deliveryData.id,
        name: formData.name,
        logo: imageUrl,
        loggedInUserId: userId,
        isActive: deliveryData.isActive,
      };

      let res = await apiService.put('UPDATE_Delivery', body);
      if (res?.data?.statusCode === 200 || res?.data?.statusCode === 201) {
        toast.success('Delivery Updated Successfully');
        navigate('/admin/Delivery');
      } else {
        toast.warning(res?.data?.message);
      }
    } catch (error) {
      console.error('Error updating Delivery:', error);
      toast.error('An error occurred while updating the Delivery.');
    }
  };

  const handleDND = () => {
    navigate('/admin/ordersDND');
  };

  return (
    <div className="container">
      <div className="p-5">
        <ImageUpload onImagesSelect={handleImagesSelect} onImageRemove={handleImageRemove} formData={formData} />
      </div>
      <div className="px-5">
        <div className="form-group row justify-content-between">
          <div className="col-md-5 col-lg-5">
            <label htmlFor="validationCustom01" className="form-label">
              Delivery Platform
            </label>
            <input type="text" className="p-2 form-control" id="validationCustom01" name="name" value={formData.name} onChange={handleInputChange} required />
            <div className="valid-feedback">Looks good!</div>
          </div>
        </div>

        <div className="row mt-5 mb-5">
          <div className="end">
            <button className="addItem-btn" type="submit" onClick={handleSubmit}>
              {isEditMode ? 'Update' : 'Save'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeliveryPlatforms;
